import React, {useEffect,useState, useRef,useContext ,useMemo,useCallback} from 'react';
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import styles from './css/user.module.css';
import apiurl from '../Api';
import Swal from 'sweetalert2';
import Select from 'react-select';
import DataTable from "react-data-table-component";
import DocumentUploadModal from '../documentUpload';
import $ from 'jquery';
import RefreshContext from './RefreshContext';
import {
  Box, 
   Button, 
  Select as MuiSelect,
  MenuItem, 
  Typography, 
  Tooltip, 
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  IconButton,
  Menu,
  ListItemIcon,Chip} from '@mui/material'; 
import { ArrowDropDown, ArrowDropUp, MoreVert as MoreVertIcon,DownloadOutlined,DeleteOutline, EditOutlined, VisibilityOutlined, KeyboardArrowRight, FormatListBulleted } from '@mui/icons-material';

const requiredOnboardingDocumentIds = [1, 2];

const isRequiredOnboardingDocsUploaded = (docs) =>
  requiredOnboardingDocumentIds.every((id) => Boolean(docs?.[id]?.uploaded || docs?.[id]?.preview));

const buildOnboardingDocumentState = (rowData = {}) => ({
  1: {
    file: null,
    preview: rowData.aadharfront || "",
    name: rowData.aadharfront ? "Aadhar Front" : "",
    type: rowData.aadharfront?.includes("application/pdf") || rowData.aadharfront?.toLowerCase?.().endsWith(".pdf") ? "application/pdf" : "image",
    uploaded: Boolean(rowData.aadharfront),
  },
  2: {
    file: null,
    preview: rowData.aadharback || "",
    name: rowData.aadharback ? "Aadhar Back" : "",
    type: rowData.aadharback?.includes("application/pdf") || rowData.aadharback?.toLowerCase?.().endsWith(".pdf") ? "application/pdf" : "image",
    uploaded: Boolean(rowData.aadharback),
  },
  3: {
    file: null,
    preview: rowData.resume || "",
    name: rowData.resume ? "Resume" : "",
    type: rowData.resume?.includes("application/pdf") || rowData.resume?.toLowerCase?.().endsWith(".pdf") ? "application/pdf" : "image",
    uploaded: Boolean(rowData.resume),
  },
  4: {
    file: null,
    preview: rowData.photo || "",
    name: rowData.photo ? "Photo" : "",
    type: rowData.photo?.includes("application/pdf") || rowData.photo?.toLowerCase?.().endsWith(".pdf") ? "application/pdf" : "image",
    uploaded: Boolean(rowData.photo),
  },
});


function Onboarded(){
const navigate = useNavigate();
const location = useLocation();
 
const { aid,aidtype} = useParams();
const [staff,setStaff]= useState([]);
const [stats,setStats]= useState([]);
const [total,setTotal]= useState(0);
const [ivrdata,setIvrData] = useState("");
const [ivr,setIvr] = useState("");
const [isEditable, setIsEditable] = useState(false);
const inputRef= useRef(null);
const [currentStep, setCurrentStep] = useState(1);
const [loadings, setTableLoading] = useState(true);
const [newloading,setNewLoading] = useState(false);
const [selectBank, setBank] = useState(null);
const [selectContract, setContract] = useState(null);
const [selectblood, setBlood] = useState(null);
const [selectSalu, setSalutation] = useState(null);
const [allDocsUploaded,setAllDocsUploaded]= useState(false);
const [contractEndDate, setContractEndDate] = useState("");

const { refreshKey } = useContext(RefreshContext);
const [requirement, setRequirement] = useState(null);

const [order, setOrder] = useState('asc'); 
const [orderBySelector, setOrderBySelector] = useState(() => (row) => row.rid); 
const [globalFilterText, setGlobalFilterText] = useState('');
const [columnFilters, setColumnFilters] = useState({});
const [contracts,setContractOptions]= useState([]);

const [metaData, setMetaData] = useState({
  appname: '',
  edit: false,
  del: false,
  add: false,
  view: false,
  typess:'',
  icon:'',
  checkbox:0,
  defaultShow:''
});

const handleReset = (form) => {
   document.querySelector(form+" form").reset();
   setBank(null);
   setSalutation(null);
   setAllDocsUploaded(false);
   setContract(null);
   setCurrentStep(1);
   $(form+" span.error-text").remove();
   $(form+" #hiddenss").val("");
};

const mySelfReset =(form)=>{
  document.querySelector(form+" .btn-close").click();
};

const totalSteps = 2;

const validateStep = (stepNumber) => {
  let valid = true;
  let emptyFields = [];

  const requiredFields = document.querySelectorAll(
    `.form-step[data-step="${stepNumber}"] [required]`
  );

  requiredFields.forEach((input) => {
    let errorSpan = input.nextElementSibling;
    if (!input.value.trim()) {
      valid = false;
      const label =
        input.closest("div")?.querySelector("label")?.innerText ||
        input.name ||
        input.placeholder ||
        "Unnamed field";

      emptyFields.push(label.trim());
      
      
      if (errorSpan && errorSpan.classList.contains("error-text")) {
        errorSpan.remove();
      }
      const span = document.createElement("span");
      span.textContent = "Empty";
      span.className = "error-text";
      span.style.color = "red";
      span.style.fontSize = "10px";
      span.style.paddingLeft = "4px";
      input.insertAdjacentElement("afterend", span);
    }
    else{
      if (errorSpan && errorSpan.classList.contains("error-text")) {
        errorSpan.remove();
      }
    }
  });

  // React-Select validation
  const reactSelects = document.querySelectorAll(
    `.form-step[data-step="${stepNumber}"] .react-select-required`
  );

  reactSelects.forEach((selectDiv) => {
    const hasValue = selectDiv.querySelector('[class*="-singleValue"]');
    let existingError = selectDiv.querySelector(".error-text");

    if (!hasValue) {
      valid = false;
      const label =
        selectDiv.closest("div")?.querySelector("label")?.innerText ||
        "Unnamed Select";
      emptyFields.push(label.trim());

      if (!existingError) {
        const span = document.createElement("span");
        span.textContent = "Empty";
        span.className = "error-text";
        span.style.color = "red";
        span.style.fontSize = "10px";
        span.style.paddingLeft = "4px";
        selectDiv.appendChild(span);
      }
    } else if (existingError) {
      existingError.remove();
    }
  });

  // Show alert with missing fields
  if (!valid && emptyFields.length > 0) {
    Swal.fire({
      icon: "warning",
      title: "Please fill all required fields!",
      html: `<b>Missing:</b> ${emptyFields.join(", ")}`,
    });
  }

  return valid;
};


const handleNext = async () => {
  if (!validateStep(currentStep)) {
    Swal.fire("Please fill required fields!", "", "warning");
    return;
  }

  if (!allDocsUploaded) {
    Swal.fire("Please upload all required documents!", "", "warning");
    return;
  }

  try {
      
    $("#showLoader").removeClass("d-none").addClass("d-flex");
      const formData1 = new FormData($("#submitform")[0]); 
      formData1.append("aid",aid);
      formData1.append("lineupcandidateid", ivrdata.reqhidden);
    
    if (currentStep === 1) {
      formData1.append("action", "step1");
      formData1.append("salu", selectSalu);
      formData1.append("blood", selectblood);
      formData1.append("contract",selectContract);
     }

    else if (currentStep === 2) {
      formData1.append("action", "step2");
      formData1.append("bankName", selectBank);
    }

     const res = await axios.post(apiurl+'onboarded.php', formData1);
    
      if (res.data.status) {
        Swal.fire({
          icon: res.data.status ? 'success' : 'error',
          title: res.data.message,
          timer: 1500,
          showConfirmButton: false,
        }).then(()=>{
            if(currentStep===1){
                setCurrentStep(currentStep + 1);
            }
            else{
                mySelfReset("#exampleModal");
            }
        });
       
      } else {
        Swal.fire("Error", res.data.message || "Step 1 save failed", "error");
      }

  } catch (err) {
    console.error("Error:", err);
    Swal.fire("Error", "Server connection failed!", "error");
  } finally {
    $("#showLoader").removeClass("d-flex").addClass("d-none");
  }
};
const handlePrev = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

const saluationType = [ 
  { value: 'Mr.', label: 'Mr.' },
  { value: 'Mrs.', label: 'Mrs.' },
  { value: 'Ms.', label: 'Ms.' },
  { value: 'Dr.', label: 'Dr.' },
  { value: 'Prof.', label: 'Prof.' },
  { value: 'Mx.', label: 'Mx.' }
];

const bloodGroupType = [
  { value: 'A+', label: 'A+' },
  { value: 'A-', label: 'A-' },
  { value: 'B+', label: 'B+' },
  { value: 'B-', label: 'B-' },
  { value: 'AB+', label: 'AB+' },
  { value: 'AB-', label: 'AB-' },
  { value: 'O+', label: 'O+' },
  { value: 'O-', label: 'O-' }
];


 const [selected, setSelected] = useState({
    profile: null,
    location: null,
    interview: null
  });

  const [options, setOptions] = useState({
    profile: [],
    location: [],
    interview: []
  });

  const selects = [
    {
      key: "profile",
      label: "Select Designation",
      placeholder: "Enter POST",
    },
    {
      key: "location",
      label: "Select Location",
      placeholder: "Enter Location",
    },
    {
      key: "interview",
      label: "Select Interview",
      placeholder: "Enter Status",
    },
  ];
  const BankOptions = [
  // Public Sector Banks
  { value: 'sbi', label: 'State Bank of India' },
  { value: 'bank_of_baroda', label: 'Bank of Baroda' },
  { value: 'punjab_national_bank', label: 'Punjab National Bank' },
  { value: 'canara_bank', label: 'Canara Bank' },
  { value: 'union_bank_of_india', label: 'Union Bank of India' },
  { value: 'bank_of_india', label: 'Bank of India' },
  { value: 'indian_bank', label: 'Indian Bank' },
  { value: 'central_bank_of_india', label: 'Central Bank of India' },
  { value: 'indian_overseas_bank', label: 'Indian Overseas Bank' },
  { value: 'uco_bank', label: 'UCO Bank' },
  { value: 'bank_of_maharashtra', label: 'Bank of Maharashtra' },
  { value: 'punjab_and_sind_bank', label: 'Punjab & Sind Bank' },

  // Private Sector Banks
  { value: 'hdfc_bank', label: 'HDFC Bank' },
  { value: 'icici_bank', label: 'ICICI Bank' },
  { value: 'axis_bank', label: 'Axis Bank' },
  { value: 'kotak_mahindra_bank', label: 'Kotak Mahindra Bank' },
  { value: 'indusind_bank', label: 'IndusInd Bank' },
  { value: 'yes_bank', label: 'YES Bank' },
  { value: 'idfc_first_bank', label: 'IDFC FIRST Bank' },
  { value: 'federal_bank', label: 'Federal Bank' },
  { value: 'south_indian_bank', label: 'South Indian Bank' },
  { value: 'karnataka_bank', label: 'Karnataka Bank' },
  { value: 'karur_vysya_bank', label: 'Karur Vysya Bank' },
  { value: 'jammu_and_kashmir_bank', label: 'Jammu & Kashmir Bank' },
  { value: 'csb_bank', label: 'CSB Bank' },
  { value: 'city_union_bank', label: 'City Union Bank' },
  { value: 'dcb_bank', label: 'DCB Bank' },
  { value: 'dhanlaxmi_bank', label: 'Dhanlaxmi Bank' },
  { value: 'nainital_bank', label: 'Nainital Bank' },
  { value: 'rbl_bank', label: 'RBL Bank' },
  { value: 'tamilnad_mercantile_bank', label: 'Tamilnad Mercantile Bank' },

  // Regional Rural Banks (RRBs)
  { value: 'andhra_pradesh_grameena_bank', label: 'Andhra Pradesh Grameena Bank' },
  { value: 'arunachal_pradesh_rural_bank', label: 'Arunachal Pradesh Rural Bank' },
  { value: 'assam_gramin_vikash_bank', label: 'Assam Gramin Vikash Bank' },
  { value: 'bihar_gramin_bank', label: 'Bihar Gramin Bank' },
  { value: 'chhattisgarh_rajya_gramin_bank', label: 'Chhattisgarh Rajya Gramin Bank' },
  { value: 'uttar_pradesh_gramin_bank', label: 'Uttar Pradesh Gramin Bank' },
  // ... you can continue adding other RRBs similarly
];

const dynamicFilterOptions = useMemo(() => {
          const options = {};
          const selectAccessors = ['location','designation','exp','payroll_status_col','bank_status_col'];
          
          selectAccessors.forEach(key => {
              const uniqueValues = new Set();
              staff.forEach(row => {
                  if (row[key]) {
                      uniqueValues.add(row[key]);
                  }
              });
              options[key] = Array.from(uniqueValues).sort();
          });
          return options;
      }, [staff]);
  
const shouldIncludeActionColumn = (
          metaData.typess?.toUpperCase() === "ADMIN" || metaData.typess?.toUpperCase() === "VENDOR" ||
          metaData.del === 1 ||
          metaData.view === 1 ||
          metaData.add === 1 ||
          metaData.edit === 1 ||
          metaData.bd === 1
  );
  

  useEffect(() => {
    if (isEditable && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditable]);

  
const EditData = async (idd,val) => { 
       $("#showLoader").removeClass('d-none').addClass('d-flex');
       
       try{
        
        if(val!='2'){
        const formdate = new FormData();
        formdate.append("lineup",idd);
        formdate.append("vtype",val);
        const response = await axios.post(apiurl + 'onboarded.php',formdate);
         if(response.data.status === true){
            const rowData = response.data.main?.[0] || {};
            const nextDocuments = buildOnboardingDocumentState(rowData);
            $("#tera_modal3").click();
            setIvrData(rowData);
            setIvr(rowData.reqhidden);
            setContractOptions(response.data.contracts);
            setDocuments(nextDocuments);
            setAllDocsUploaded(isRequiredOnboardingDocsUploaded(nextDocuments));


         }
         else{
                  Swal.fire({
                    position: "top-center",
                    icon: "error",
                    title: "Something Went Wrong !",
                    showConfirmButton: false,
                    timer: 2000
                  });
         }
        }
        else{
        const response = await axios.get(apiurl + 'requirement.php?edit=' + idd);
        
        if (response.data.status == true) {
             setRequirement(response.data.data[0]);
            $("#table_modal").click();
        } else {
          alert("data not found");
        }

        }

       }
       catch (error) {
        console.log("bhai error", error.response?.data?.message); // Handle errors with informative messages
       }
       finally {
         $("#showLoader").removeClass('d-flex').addClass('d-none');
       }
};

const [currentPage, setCurrentPage] = useState(1);
const [totalRows, setTotalRows] = useState(0); // Set this from your API response
const limit = 50; 
const maxPage = Math.ceil(totalRows / limit);
  const [documents,setDocuments] = useState({
  1:{file:null,preview:ivrdata.aadharfront || "",uploaded:false},
  2:{file:null,preview:ivrdata.aadharback || "",uploaded:false},
  3:{file:null,preview:ivrdata.resume || "",uploaded:false},
  4:{file:null,preview:ivrdata.photo || "",uploaded:false}
});
const fileRefs = useRef({});

const fetchData = async (page) => {
  const response = await axios.get(apiurl+'onboarded.php?subdomain=react&lid='+aid+'&page='+page); // Replace with your API endpoint
 
   setStaff(response.data.staff || []);
   setTotalRows(response.data.total_count);
   setStats(response.data.stats || []);
   setOptions({ profile: response.data.post, location: response.data.city ,interview:[
      { value: '', label: 'All' }, 
      { value: 'pending', label: 'Pending' },
      { value: 'success', label: 'Selected' },
      { value: 'decline', label: 'Rejected' }
   ]});

   setMetaData({
  appname: response.data.appname,
  edit: response.data.edit,
  del: response.data.del,
  add: response.data.add,
  view: response.data.view,
  typess:response.data.typess,
  icon:response.data.icon,
  defaultShow:response.data.defaultShow,
  checkbox:response.data.checkbox
   });

 setTotal(response.data.total);
 setTableLoading(false);

};


const displayCount = 5;
let startPage = Math.max(1, currentPage - Math.floor(displayCount / 2));
let endPage = startPage + displayCount - 1;

if (endPage > maxPage) {
    endPage = maxPage;
    startPage = Math.max(1, endPage - displayCount + 1);
}

const pages = [];
for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
}

useEffect(() => {
  document.title = "Onboarded Candidate | MERAQUI";
    fetchData(currentPage);
 
}, [aid,refreshKey,currentPage]);

useEffect(() => {
  const params = new URLSearchParams(location.search);
  const verifyId = params.get("verify");
  if (!verifyId) return;
  EditData(verifyId, aid);
  navigate(`/admin/onboarding/${aid}`, { replace: true });
}, [location.search, aid]);


useEffect(() => {
  if (!ivrdata) return;

  if (bloodGroupType.length > 0 && ivrdata.blood) setBlood(ivrdata.blood);
  if (saluationType.length > 0 && ivrdata.salu) setSalutation(ivrdata.salu);
  if (BankOptions.length > 0 && ivrdata.bank) setSalutation(ivrdata.bank);
}, [ivrdata,bloodGroupType, saluationType,BankOptions]);


const stableSort = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
};

const getComparator = (order, orderBy) => {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
};

const descendingComparator = (a, b, orderBy) => {
    const valA = orderBy(a);
    const valB = orderBy(b);

    if (valB < valA) {
        return -1;
    }
    if (valB > valA) {
        return 1;
    }
    return 0;
};


const ColumnHeaderWithFilter = ({ 
    column, 
    orderBySelector, 
    order, 
    handleRequestSort, 
    columnFilters, 
    setColumnFilters,
}) => {

    const [localOpenKey, setLocalOpenKey] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [tempFilter, setTempFilter] = useState("");

    const accessorKey = column.accessorKey;

    const isMenuOpen = localOpenKey === accessorKey;
    const currentFilter = String(columnFilters[accessorKey] || '');
    const isSorted = orderBySelector === column.selector;

    useEffect(() => {
        setTempFilter(currentFilter);
    }, [currentFilter]);

    const handleClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
        setLocalOpenKey(accessorKey);
        setTempFilter(currentFilter);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setLocalOpenKey(null);
    };

    const handleFilterChange = (e) => {
        setColumnFilters(prev => ({
            ...prev,
            [accessorKey]: e.target.value
        }));
    };

    const handleTempChange = (e) => {
        setTempFilter(e.target.value);
    };

    const applySearch = () => {
        setColumnFilters(prev => ({
            ...prev,
            [accessorKey]: tempFilter
        }));
        handleClose();
    };

    const isSortable = !!column.selector;
    const isFilterable = !!column.filterType;

    // --- Custom Filter Input Renderer ---
    const renderFilterInput = () => {

        if (column.filterType === 'select') {

            const filterOptions = column.dynamicFilterOptions || [];

            return (
                <MuiSelect
                    label={`Filter ${column.header}`}
                    variant="outlined"
                    size="small"
                    value={currentFilter}
                    onChange={handleFilterChange}
                    sx={{ width: '100%' }}
                >
                    <MenuItem value="">— All —</MenuItem>
                    {filterOptions.map(option => (
                        <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                </MuiSelect>
            );
        }

        if (column.filterType === 'date') {
            return (
                <TextField
                    label={`Filter ${column.header}`}
                    type="date"
                    variant="outlined"
                    size="small"
                    value={currentFilter}
                    onChange={handleFilterChange}
                    InputLabelProps={{ shrink: true }}
                    sx={{ width: '100%' }}
                />
            );
        }

        // Default: text filter (with Search button)
        return (
            <>
                <TextField
                    label={`Filter ${column.header}`}
                    variant="outlined"
                    size="small"
                    value={tempFilter}
                    onChange={handleTempChange}
                    autoFocus
                    sx={{ width: '100%' }}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            applySearch();
                        }
                    }}
                />

                <Button
                    variant="contained"
                    size="small"
                    onClick={applySearch}
                    sx={{ mt: 1, textTransform: 'none', width: "100%" }}
                >
                    Search
                </Button>
            </>
        );
    };


    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                '& .MuiTableSortLabel-root': { flexGrow: 1 }
            }}
        >
            <TableSortLabel
                active={isSorted}
                direction={isSorted ? order : 'asc'}
                onClick={() => isSortable && handleRequestSort(column.selector)}
                IconComponent={isSorted ? (order === 'desc' ? ArrowDropDown : ArrowDropUp) : undefined}
                sx={{
                    cursor: isSortable ? 'pointer' : 'default',
                    justifyContent: column.headerAlign === 'center' ? 'center' : 'flex-start',
                    '&.Mui-active': {
                        color: 'primary.main',
                        fontWeight: 'bold',
                    }
                }}
            >
                {column.header}
            </TableSortLabel>

            {isFilterable && (
                <>
                    <IconButton
                        aria-label="filter"
                        size="small"
                        onClick={handleClick}
                        sx={{
                            ml: 1,
                            p: 0,
                            color: currentFilter ? 'primary.main' : 'text.secondary',
                        }}
                    >
                        <MoreVertIcon fontSize="inherit" />
                    </IconButton>

                    <Menu
                        anchorEl={anchorEl}
                        open={isMenuOpen}
                        onClose={handleClose}
                        onClick={(e) => e.stopPropagation()}
                        PaperProps={{
                            sx: { width: 250, p: 1, boxShadow: 6, borderRadius: 2 }
                        }}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    >

                        <Box sx={{ width: '100%', p: 1 }}>
                            {renderFilterInput()}
                        </Box>

                        {currentFilter && (
                            <Button
                                onClick={() => {
                                    setColumnFilters(prev => ({
                                        ...prev,
                                        [accessorKey]: ''
                                    }));
                                    handleClose();
                                }}
                                size="small"
                                color="error"
                                sx={{ mt: 1, textTransform: 'none', width: "100%" }}
                            >
                                Clear Filter
                            </Button>
                        )}

                    </Menu>
                </>
            )}
        </Box>
    );
};

const columns = useMemo(() => {
        let baseColumns = [
            { accessorKey: 'rid', header: 'Req. ID', size: 150, selector: (row) => row.requireid, filterType: 'text', headerAlign: 'center' },
            { accessorKey: 'lineup_source', header: 'Source', size: 150, selector: (row) => row.lineup_source || row.campid, filterType: 'text' },
            { accessorKey: 'cname', header: 'Client Name', size: 150, selector: (row) => row.client, filterType: 'text' },
            { 
                accessorKey: 'name', 
                header: 'Name', 
                size: 150, 
                selector: (row) => row.name, 
                filterType: 'text'
            },
            { 
                accessorKey: 'mobile', 
                header: 'Mobile Number', 
                size: 150, 
                selector: (row) => row.mobile, 
                filterType: 'text'
            },
            { 
                accessorKey: 'designation', 
                header: 'Designation', 
                size: 150, 
                selector: (row) => row.profile, 
                filterType: 'select',
                dynamicFilterOptions: dynamicFilterOptions['designation']

            },
            { 
                accessorKey: 'location', 
                header: 'Location', 
                size: 150, 
                selector: (row) => row.location, 
                filterType: 'select',
                dynamicFilterOptions: dynamicFilterOptions['location']
            },
            { 
                accessorKey: 'education', 
                header: 'Qualification', 
                size: 150, 
                selector: (row) => JSON.stringify(row.qual), 
                filterType: 'text'
            },{ 
                accessorKey: 'exp', 
                header: 'Experience', 
                size: 150, 
                selector: (row) => row.exp, 
                filterType: 'select',
                dynamicFilterOptions: dynamicFilterOptions['exp']
            },
             
            {
            accessorKey: 'bank_status_col',
            header: 'Bank Status',
            minWidth: "180px",
            wrap: true,
            Cell: ({ row: { original: row } }) => {
                const bankstatus = row.bankstatus?.toLowerCase(); // Assuming bankstatus is on the row object
                if (bankstatus === "pending") {
                    return (
                        <button
                            className="btn btn-sm btn-primary fw-semibold"
                            onClick={() => EditData(row.id, aid)} 
                        >
                            Verify
                        </button>
                    );
                }

                if (bankstatus === "success") {
                    return <span className="text-success fw-semibold">Bank Verified</span>;
                }

                if (bankstatus === "decline") {
                    // Assuming EditData and aid are available in this scope
                    return (
                        <div className="d-flex flex-column">
                            <span className="text-danger fw-semibold">Bank Failed</span>
                            <button
                                className="btn btn-sm btn-warning fw-semibold mt-1"
                                onClick={() => EditData(row.id, aid)}
                            >
                                Re-Verify
                            </button>
                        </div>
                    );
                }
                return null;
            },
            filterType: 'select',
                dynamicFilterOptions: dynamicFilterOptions['bank_status_col']
        },

        {
            accessorKey: 'payroll_status_col',
            header: 'Payroll Status',
            minWidth: "160px",
            wrap: true,
            Cell: ({ row: { original: row } }) => {
                const payrollStatus = row.payroll?.toLowerCase(); // Assuming payroll is on the row object
                if (payrollStatus === "success") {
                    return <span className="text-success fw-semibold">Payroll Approved</span>;
                }
                else if (payrollStatus === "decline") {
                    return <span className="text-danger fw-semibold">Payroll Rejected</span>;
                }
                else {
                    return <span className="text-warning fw-semibold">Payroll Pending</span>;
                }
            },
            filterType: 'select',
                dynamicFilterOptions: dynamicFilterOptions['payroll_status_col']
        },

        ];

      return baseColumns;
   }, [dynamicFilterOptions, shouldIncludeActionColumn, metaData.bd]);

    const handleRequestSort = useCallback((selector) => {
        const isAsc = orderBySelector === selector && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBySelector(() => selector);
    }, [order, orderBySelector]);

    const processedData = useMemo(() => {
        let filtered = staff;
        const lowerCaseFilter = globalFilterText.toLowerCase();

        // 1. Apply Global Filter
        if (lowerCaseFilter) {
            filtered = filtered.filter(row => 
                columns.some(column => {
                    const value = column.selector ? String(column.selector(row)) : '';
                    return value.toLowerCase().includes(lowerCaseFilter);
                })
            );
        }

        // 2. Apply Column Filters
        filtered = filtered.filter(row => {
            return columns.every(column => {
                const accessorKey = column.accessorKey;
                const filterValue = columnFilters[accessorKey];

                if (!filterValue) return true;
                if (!column.selector) return true;

                const rowValue = String(column.selector(row));

                switch (column.filterType) {
                    case 'select':
                        // Must match the selected value exactly
                        return rowValue === filterValue; 
                        
                    case 'date':
                        // Check if the date string (e.g., '2024-01-15') includes the filter date
                        return rowValue.includes(filterValue); 
                        
                    case 'text':
                    default:
                        return rowValue.toLowerCase().includes(filterValue.toLowerCase());
                }
            });
        });

        // 3. Sorting Logic
        const sortColumn = columns.find(col => col.selector === orderBySelector);

        if (sortColumn) {
            return stableSort(filtered, getComparator(order, sortColumn.selector));
        }
        
        return filtered;

    }, [staff, columns, order, orderBySelector, globalFilterText, columnFilters]);


const RenderReqIdCell = useCallback(({ row }) => {
    const rowData = row;
     const isViewDetailClickable = true; // Set to true or use metaData.view check if needed
    
    let statsColor = '#10B981'; let idTooltipContent = 'Requirement In-process';
    if (rowData.rstatus.toLowerCase() === 'onhold') {
        statsColor = '#F59E0B'; idTooltipContent='Requirement Onhold';
    } else if (rowData.rstatus.toLowerCase() === 'closed') {
        statsColor = '#9CA3AF'; idTooltipContent='Requirement Closed';
    }
 return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, whiteSpace: 'nowrap' ,width:150}}>

           <Tooltip title={isViewDetailClickable ? 'View Detail' : ''} arrow>
                <IconButton
                    size="small"
                    onClick={() => EditData(rowData.reqidhidden,"2")} 
                    sx={{
                        color: 'orange', 
                        p: 0.5,
                        '&:hover': {
                            color: isViewDetailClickable ? '#0056b3' : 'text.disabled',
                            backgroundColor: 'transparent'
                        }
                    }}
                >
                    <VisibilityOutlined sx={{ fontSize: '1rem' }} />
                </IconButton>
            </Tooltip>
            
             <Tooltip title={idTooltipContent} arrow>
                <Button
                    sx={{
                        background: "none",
                        border: "none",
                        color: statsColor, // Use status color for the ID text
                         padding: 0,
                        minWidth: 0, 
                        fontWeight: 500,
                        textAlign: 'left',
                        textTransform: 'none',
                        fontSize: '0.875rem',
                        '&:hover': { backgroundColor: 'transparent' }
                    }}
                >
                    {rowData.requireid}
                </Button>
            </Tooltip>
            
        </Box>
    );
}, [navigate, EditData]);



  // ✅ Loader while checking session
  if (newloading) {
    
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white/90 z-50">
        <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }


  const handleDocumentsComplete = (status) => {
    setAllDocsUploaded(status);
  };
 

const handleFileSelect = (id,file) => {

  if(!file) return;

  let preview = "";
  let type = file.type;

  if(file.type === "application/pdf"){
    preview = URL.createObjectURL(file);
  }else{
    preview = URL.createObjectURL(file);
  }

  setDocuments(prev => ({
    ...prev,
    [id]:{
      ...prev[id],
      file:file,
      preview:preview,
      name: file.name,
      type: type,
      uploaded: false,
    }
  }));

};

const uploadDocument = async (id) => {

  const doc = documents[id];

  if(!doc.file){
    Swal.fire("Select file first");
    return;
  }

  $("#showLoader").removeClass("d-none").addClass("d-flex");

  try{

    const formData = new FormData();
    formData.append("document",doc.file);
    formData.append("documentype",id);
    formData.append("email",ivrdata.email);
    formData.append("userId",ivrdata.reqhidden);
    formData.append("action","upload");

    const res = await axios.post(apiurl+"upload.php",formData);

    if (res.data.status) {
      setDocuments((prev) => {
        const nextDocuments = {
          ...prev,
          [id]: {
            ...prev[id],
            file: null,
            preview: res.data.fileURL || prev[id]?.preview || "",
            name: doc.name || prev[id]?.name || "",
            type: doc.type || prev[id]?.type || "image",
            uploaded: true,
          },
        };
        setAllDocsUploaded(isRequiredOnboardingDocsUploaded(nextDocuments));
        return nextDocuments;
      });
    }

    Swal.fire({
      icon: res.data.status ? "success":"error",
      title: res.data.message
    });

  }catch(err){
    console.log(err);
  }

  $("#showLoader").removeClass("d-flex").addClass("d-none");

};

const renderUploadBox = (id,label,required=false) => {

  const doc = documents[id];

  return (
   <div className="upload-card">
      <input type="file" accept=".jpg,.jpeg,.png,.pdf" ref={(el)=>fileRefs.current[id] = el} style={{display:"none"}} onChange={(e)=>handleFileSelect(id,e.target.files[0])}/>

      {doc.preview ?

      <div className="preview-box">

        {doc.type === "application/pdf" ?
          <div className="pdf-preview">
            <a target='_blank' href={doc.preview}>View Pdf</a>
          </div>
        :
        <img src={doc.preview} alt="preview"/>
        }

      </div>: <div className="upload-placeholder" onClick={()=>fileRefs.current[id].click()}>
        <span>Select File</span>
      </div>

      }

      <div className="upload-actions">

        <button className="btn btn-success btn-sm" type="button" onClick={()=>uploadDocument(id)}> 
          Upload
        </button>

        <button className="btn btn-warning btn-sm" type="button" onClick={()=>fileRefs.current[id].click()}>
          Change
        </button>

      </div>

    </div>

  )

}

return(
<>

<button data-bs-toggle="offcanvas" id="tera_modal3" data-bs-target="#exampleModal" type="button" style={{ display: 'none' }}></button>
     <button data-bs-toggle="modal" id="table_modal" data-bs-target="#tableModal" type="button" style={{ display: 'none' }}></button>

     <div className="offcanvas offcanvas-top" style={{ maxHeight: '100%', height: 'auto', backgroundColor: 'rgb(245 245 245)' }} tabIndex="-1" id="exampleModal"  data-bs-keyboard="false">
        <div className="offcanvas-header border-bottom border-block-end-dashed">
          <h5 className="offcanvas-title" id="offcanvasRightLabel1">{metaData.appname}</h5>
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas" onClick={()=>{handleReset("#exampleModal");}} aria-label="Close"></button>
        </div>
        <div className="offcanvas-body" style={{ paddingBottom: '80px' }}>

<div className='d-flex'>

<form id="submitform" encType="multipart/form-data" className='order-2'>
  
<div className={`form-step ${currentStep === 1 ? "active" : ""}`} data-step="1">

           <div className="row g-3">
                
           <div className="col-xl-3 col-lg-3 col-md-6 mb-2">
              <label htmlFor="campid" className="form-label">Source</label>
              <input defaultValue={ivrdata.lineup_source || ivrdata.campid || ""} type="text" className="form-control" placeholder="Source" readOnly disabled/>
            </div>
            <div className="col-xl-3 col-lg-3 col-md-6 mb-2">
              <label htmlFor="requireid" className="form-label">Requirement Id</label>
              <input defaultValue={ivrdata.requireid || ""} name='requireid' type="text" className="form-control" placeholder="Require ID" readOnly disabled/>
            </div>
           
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="client" className="form-label">Client Name</label>
              <input defaultValue={ivrdata.client || ""} type="text" className="form-control" placeholder="Client name" readOnly disabled/>
            </div>

            <div className="col-2 mb-3">
              <label className="form-label">Requirement Details</label>
              <button className="btn btn-link" type="button"  data-bs-toggle="collapse" data-bs-target="#moreInfoCollapse" aria-expanded="false" aria-controls="moreInfoCollapse" style={{ textDecoration: 'none' }}>
                  <span className="me-2">More Details...</span> 
                     <i className="bi bi-chevron-down"></i> 
             </button>
            </div>
        </div>
       <div className="collapse" id="moreInfoCollapse" style={{border: '2px solid rgb(215 226 255)',padding: '10px',marginBottom: '11px',borderRadius: '10px'}}>    
            <div className='row'>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="jobTitle" className="form-label">Requirement Name/Job Title</label>
              <input defaultValue={ivrdata.jobTitle || ""} type="text" className="form-control" placeholder="JOB TITLE" readOnly disabled/>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="jobTitle" className="form-label">Requirement Location</label>
              <input defaultValue={ivrdata.location || ""} type="text" className="form-control" placeholder="Location" readOnly disabled/>
            </div>
            
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="recName" className="form-label">Rec Name</label>
              <input defaultValue={ivrdata.recname || ""} type="text" className="form-control" placeholder="Rec Name" readOnly disabled/>
            </div>

            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="cost" className="form-label">Cost Center</label>
              <input defaultValue={ivrdata.costCenter || ""} type="text" className="form-control" placeholder="Cost Center" readOnly disabled/>
            </div>

             <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="rname" className="form-label">Recruiter Name</label>
              <input defaultValue={ivrdata.rname || ""} type="text" className="form-control" placeholder="Recruiter Name" readOnly disabled/>
            </div>

            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="remail" className="form-label">Recruiter Email</label>
              <input defaultValue={ivrdata.remail || ""} type="text" className="form-control" placeholder="Recruiter Email" readOnly disabled/>
            </div>
              <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="spocPersonId" className="form-label">SPOC Person ID</label>
              <input defaultValue={ivrdata.spoc || ""} type="text" className="form-control" placeholder="SPOC Person ID" readOnly disabled/>
            </div>
          
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="lineRequestDate" className="form-label">Line Request Date</label>
              <input defaultValue={ivrdata.ldate || ""} type="text" className="form-control" placeholder="Line Request Date" readOnly disabled/>
            </div>
           
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="interviewDate" className="form-label">Interview Date</label>
              <input defaultValue={ivrdata.idate || ""} type="text" className="form-control" placeholder="Interview Date" readOnly disabled/>
            </div>
             
            </div>
        </div> 

        <div className="row mb-3">

  {/* Aadhar Front */}
  <div className="col-md-3 mb-3">
    <label className="form-label">
      <span className="text-danger">*</span> Aadhar Front
    </label>
    {renderUploadBox(1,"Aadhar Front",true)}
  </div>

  {/* Aadhar Back */}
  <div className="col-md-3 mb-3">
    <label className="form-label">
      <span className="text-danger">*</span> Aadhar Back
    </label>
    {renderUploadBox(2,"Aadhar Back",true)}
  </div>

  <div className="col-md-3 mb-3">
    <label className="form-label">Resume (Optional)</label>
    {renderUploadBox(3,"Resume",false)}
  </div>

  {/* Photo */}
  <div className="col-md-3 mb-3">
    <label className="form-label">Passport Photo (Optional)</label>
    {renderUploadBox(4,"Photo",false)}
  </div>

</div>

        <div className='row'> 
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="candidateName" className="form-label">Candidate Name</label>
              <input defaultValue={ivrdata.name || ""} type="text" className="form-control" placeholder="Candidate Name" readOnly disabled/>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="candidateMobile" className="form-label">Candidate Mobile</label>
              <input defaultValue={ivrdata.mobile || ""} type="text" className="form-control" placeholder="Candidate Mobile" readOnly disabled/>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="candidateDesignation" className="form-label">Candidate Designation</label>
              <input defaultValue={ivrdata.profile || ""} type="text" className="form-control" placeholder="Candidate Designation" />
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="candidateCity" className="form-label">Candidate Location</label>
              <input defaultValue={ivrdata.city || ""} type="text" className="form-control" placeholder="Candidate City" />
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="candidateQualification" className="form-label">Candidate Qualification</label>
              <input defaultValue={JSON.stringify(ivrdata.qual)} type="text" className="form-control" placeholder="Candidate Qualification" />
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
              <label htmlFor="candidateExperience" className="form-label">Candidate Experience</label>
              <input defaultValue={ivrdata.exp || ""} type="text" className="form-control" placeholder="Experience" />
            </div>

             <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="age" className="form-label">DOB </label>
                  <input id="age" defaultValue={ivrdata.dob || ""}  name="age" type="date" className="form-control" placeholder="Date of Birth" />
                </div>

              <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="age" className="form-label">Age </label>
                  <input id="age" defaultValue={ivrdata.age || ""}  name="age" type="text" className="form-control" placeholder="Age" />
                </div>
           
          
                <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="state" className="form-label">STATE</label>
                  <input id="state" name="state" type="text" className="form-control" placeholder="State" defaultValue={ivrdata.state || ""} />
                </div>
                  <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="city" className="form-label">District</label>
                  <input id="city" defaultValue={ivrdata.city || ""} name="city" type="text" className="form-control" placeholder="City" />
                </div>
              
                
                <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="pincode" className="form-label">PINCODE</label>
                  <input id="pincode" defaultValue={ivrdata.pincode || ""} name="pincode" type="text" className="form-control" placeholder="Pincode" />
                </div>
          

              <div className="col-lg-4 col-md-4 col-sm-6">
                  <label htmlFor="address" className="form-label">Address</label>
                  <input placeholder='Address' id='address' name='address' className='form-control' required defaultValue={ivrdata.address || ""}/>
                </div>

               <div className="col-xl-4 col-lg-4 col-md-6">
                                <label htmlFor="groups" className="form-label"><span className='text-danger'>*</span>Select Blood Group</label>
                            <div className="react-select-required">
                                <Select
                                  options={bloodGroupType || []}
                                  value={(bloodGroupType || []).find(opt => opt.value === selectblood) || null}
                                  onChange={(option) => setBlood(option ? option.value : null)}
                                  placeholder="Select Blood Group"
                                />
                              </div>
                          </div>

           <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="aadhar" className="form-label"><span className='text-danger'>*</span>Aadhar Number</label>
                  <input id="aadhar" name="aadhar" type="text" defaultValue={ivrdata.aadhar || ""} maxLength="12" className="form-control" placeholder="Aadhar Card 12 digit Number" required/>
                </div>
          
           <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="uan" className="form-label">UAN NUMBER</label>
                  <input id="uan" name="uan" type="text" maxLength="12"  defaultValue={ivrdata.uan || ""} className="form-control" placeholder="UAN 12 digit Number" required/>
                </div>

                           <div className="col-xl-4 col-lg-4 col-md-6">
                                <label htmlFor="placementType" className="form-label"><span className='text-danger'>*</span>Salutation</label>
                               <div className="react-select-required">
                                <Select
                                  options={saluationType || []}
                                  value={(saluationType || []).find(opt => opt.value === selectSalu) || null}
                                  onChange={(option) => setSalutation(option ? option.value : null)}
                                  placeholder="Select Salutation"
                                />
                                </div>
                              </div>

                    <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="edate" className="form-label"><span className='text-danger'>*</span>Enter Working City </label>
                  <input name="working" id="working"  defaultValue={ivrdata.working || ""} type="text" placeholder='Working City' className="form-control" required/>
                </div>

                <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="edate" className="form-label"><span className='text-danger'>*</span>Expected Date of Joining </label>
                  <input id="edate" name="edate"  defaultValue={ivrdata.edate || ""} type="date" className="form-control" required/>
                </div>

                <div className="col-xl-4 col-lg-4 col-md-6">
                      <label htmlFor="contract" className="form-label"><span className='text-danger'>*</span>Select Contract</label>
                      <div className="react-select-required">
                        <Select options={contracts} value={(contracts || []).find(opt => opt.value === selectContract) || null} onChange={(option) => {setContract(option ? option.value : null); setContractEndDate(option ? option.end_date : "");}} placeholder="Select Contract"/>
                      </div>
                </div>
                
                <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="cdate" className="form-label"><span className='text-danger'>*</span>Contract End Date</label>
                  <input id="cdate" name="cdate" placeholder='YYYY-MM-DD' type="text" required className="form-control" value={contractEndDate} disabled={selectContract == null}/>
                </div>
             </div>
         
</div>

 <div className={`form-step ${currentStep === 2 ? "active" : ""}`} data-step="4">
  <div className="row g-3">
   <div className="col-6 mb-2">
              <label htmlFor="candidateMobile" className="form-label">Candidate Mobile</label>
              <input defaultValue={ivrdata.bankmobile ? ivrdata.bankmobile : (ivrdata.mobile || "")} name='bankmodile' type="text" className="form-control" placeholder="Candidate Mobile" readOnly={!isEditable}/>
              <div className="form-check">
          <input
             ref={inputRef}
            className="form-check-input"
            type="checkbox"
            id="editMobileCheck"
            checked={isEditable}
            onChange={() => setIsEditable(!isEditable)}
          />
          <label className="form-check-label" htmlFor="editMobileCheck">
            Want to Change Mobile Number ?
          </label>
        </div>
  </div>
   <div className="col-6">
    <label htmlFor="account" className="form-label">ACCOUNT NUMBER</label>
    <input id="account" name="account" type="text" className="form-control" placeholder="Account Number" defaultValue={ivrdata.bankaccount || ""}/>
  </div>
  <div className="col-6">
    <label htmlFor="bank" className="form-label">Select Bank</label>
   <Select
                    options={BankOptions || []}
                    value={(BankOptions || []).find(opt => opt.value === selectBank) || null}
                    onChange={(option) => setBank(option ? option.value : null)}
                    placeholder="Select Bank"
                  />
  </div>
   <div className="col-6">
    <label htmlFor="bankifsc" className="form-label">IFSC CODE</label>
    <input id="bankifsc" name="bankifsc" type="text" className="form-control" placeholder="Enter IFSC Code" defaultValue={ivrdata.bankifsc || "" } />
  </div>
</div>

 </div>

<input type="hidden" name="hidden" id="hiddenss" />

</form>

<div className="wizard-footer">
    {currentStep > 1 && (
        <button type="button" onClick={handlePrev} className="btn prev-btn">
            BACK
        </button>
    )}
    {currentStep < totalSteps && (
        <button type="button" onClick={handleNext} className="btn next-btn">
            NEXT
        </button>
    )}
    {currentStep === totalSteps && (
        <button type="button" onClick={handleNext} id="initiateBtn" className="btn next-btn">
            VERIFY BANK DETAILS
        </button>
    )}
</div>
     
    </div>    
      

        </div>

      </div>

  <div className="modal effect-super-scaled fade" id="tableModal" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="tableModal" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-body" style={{maxHeight:'90vh',overflowX:'auto'}}>
<h5><strong>Detail</strong></h5>

<table className="table table-bordered" style={{ tableLayout: "fixed" }}>
  <tbody>
    {requirement && [
      ["RecID", "Branch", "CTC ", "", requirement.rid, requirement.branchh, requirement.ctcRange,""],
      ["Gender", "RecName", "Age", "Requirement Plan Dates", requirement.gender?.toUpperCase(), requirement.recname, requirement.ageRange, requirement.planDate],
      ["Client Name", "Anchor", "Location", "Experience", requirement.cidd, requirement.anchor, requirement.location, requirement.expRange],
      ["Education Type", "Commercials", "Designation", "Contact Name", requirement.education, requirement.commercials, requirement.posts, requirement.contactName],
      ["Contract", "Placement Type", "Job Title", "Requirement Status", requirement.contract, requirement.placementType, requirement.jobTitle, requirement.statuses],
      ["Cost Center", "Requirement Create Time", "No Of Position", "Pincode", requirement.costCenterbig, requirement.datestimes, requirement.noOfPosition, requirement.pincode],
    ].map((row, idx) => (
      <React.Fragment key={idx}>
        {/* Headings Row */}
        <tr>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[0]}</th>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[1]}</th>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[2]}</th>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[3]}</th>
        </tr>

        {/* Values Row */}
        <tr>
          <td>{row[4] || "-"}</td>
          <td>{row[5] || "-"}</td>
          <td>{row[6] || "-"}</td>
          <td>{row[7] || "-"}</td>
        </tr>
      </React.Fragment>
    ))}

    <tr>
       <th style={{ backgroundColor: "#e9ecef" }}>Keywords</th>
        <td colSpan="3">N/A</td>
    </tr>
  </tbody>
</table>


<h5 className="mt-4"><strong>Statistics Overview</strong></h5>
{/* New Statistics Overview Table */}
<table className="table table-bordered mt-4" style={{ tableLayout: 'fixed', width: '100%' }}>
  <tbody>
    {requirement && [
      ["Total Candidates", "Vendor Candidates", "Recruiter Candidates", requirement.tcandidate, requirement.vcandidate, requirement.rcandidate],
      ["Total Campaigns", "Campaign IVR Completed", "Campaign IVR Pending", requirement.tcampaign, requirement.isuccess, requirement.ipending],
      ["IVR Total Call ( Candidates )", "IVR Pending ( Candidates )", "IVR Completed ( Candidates )", requirement.ivrtotal, requirement.ivrpending, requirement.ivrcompleted],
      ["Lineups Candidates", "Selected Candidates", "Joined Candidates", requirement.lineup, requirement.selected, requirement.joined]
    ].map((row, idx) => (
      <>
        {/* Headings row */}
        <tr key={`st-head-${idx}`}>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[0]}</th>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[1]}</th>
          <th style={{ backgroundColor: "#e9ecef" }}>{row[2]}</th>
        </tr>

        {/* Values row */}
        <tr key={`st-val-${idx}`}>
          <td>{row[3]}</td>
          <td>{row[4]}</td>
          <td>{row[5]}</td>
        </tr>
      </>
    ))}
  </tbody>
</table>


        
            </div>
            <div className='modal-footer' style={{ padding: '0px' }}>
              <button type="button" className="btn btn-danger btn-sm" data-bs-dismiss="modal" id="okayClose" aria-label="Close">Close</button>
            </div>
          </div>
        </div>
      </div>

<div className="main-content app-content">
                 
 <div className="container-fluid">

    <div className="row">
  
  <div class="col-xl-12 mt-4">
      <div class="card custom-card">
          <div class="card-header" style={{display:'flex',justifyContent:'space-between'}}><div class="card-title">Onboard Stats</div>
            <Tooltip title="Download Candidates Data" arrow>
            <IconButton
              size="medium"
              onClick={() => {
                window.location = `${apiurl}download.php?subdomain=react&export=xls&aid=${aid}&aidtype=${aidtype}`;
              }}
              sx={{
                color: '#fff',
                background: 'linear-gradient(135deg, #1976d2, #42a5f5)',
                borderRadius: '10px',
                p: 1,
                boxShadow: '0 4px 12px rgba(25, 118, 210, 0.35)',
                transition: 'all 0.25s ease',
                '&:hover': {
                  background: 'linear-gradient(135deg, #0d47a1, #1976d2)',
                  transform: 'translateY(-1px)',
                  boxShadow: '0 6px 16px rgba(13, 71, 161, 0.45)',
                },
                '&:active': {
                  transform: 'scale(0.95)',
                },
              }}
            >
              <DownloadOutlined sx={{ fontSize: '1.4rem' }} />
            </IconButton>
          </Tooltip>
            <button className="btn btn-primary ms-2" onClick={()=> navigate(-1)}>Back</button>
          </div>
          <div class="card-body">
              <div class="row gy-md-0 gy-3" style={{gap:'15px 60px'}}>
   
   {stats.map((item, index) => (
   
  <div class="col-xxl-2 col-xl-2 col-lg-4 col-md-4 col-sm-12" key={index}>
                    <div class="d-flex align-items-top">
                        <div class="me-3">
                            <span class={"avatar avatar-rounded text-white"} style={{backgroundColor:item.color}}>
                                <i class={`${item.icon} fs-28`}></i>
                            </span>
                        </div>
                        <div>
                            <span class="d-block mb-1 text-muted">{item.label}</span>
                            <h6 class="fw-semibold mb-0">{item.count}</h6>
                        </div>
                    </div>
                </div>
    ))}
   </div>
   
          </div>
      </div>
  </div>
  
  </div>

<div className="row">
            <div className="col-xxl-12 col-xl-12 ">
              <div className="card custom-card">
                <div className="card-header justify-content-between" style={{ paddingBottom: '15px', alignItems: 'normal' }}>
                  <div>
                    <h6 className="fs-16">{metaData.defaultShow}</h6>
                  </div>
                  <div className="d-flex mt-sm-0 mt-2 align-items-center">

                    <div className="input-group" >
                      <input type="search" className="form-control" placeholder="Search Onboarded Candidates" id="search-member"  value={globalFilterText}  onChange={(e) => setGlobalFilterText(e.target.value)} />
                    </div>      
                  </div>

                </div>
                <div className="card-body" style={{ padding: '0px' }}>

           <TableContainer sx={{ maxHeight: '700px'}}>
                <Table stickyHeader aria-label="requirement tracker table">
                    
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.accessorKey}
                                    sx={{ 
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        p: 2.5,
                                        fontSize: '0.85rem', 
                                        verticalAlign: 'top',
                                    }}>
                                    <ColumnHeaderWithFilter
                                        column={column}
                                        orderBySelector={orderBySelector}
                                        order={order}
                                        handleRequestSort={handleRequestSort}
                                        columnFilters={columnFilters}
                                        setColumnFilters={setColumnFilters}
                                    />
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>


<TableBody>
    {processedData.map((row, index) => (
        <TableRow key={index} >
            {columns.map((column) => {
                let cellContent;
                const cellWidth = column.size ? column.size : 150;
                switch (column.accessorKey) {
                    case 'rid':
                        cellContent = <RenderReqIdCell row={row} />; 
                        break;
                    
                    // 1. Payroll Status
                    case 'payroll_status_col': // Use the accessorKey you defined for this column
                        const payrollStatus = row.payroll?.toLowerCase();
                        if (payrollStatus === "success") {
                            cellContent = <span className="text-success">Payroll Approved</span>;
                        }
                        else if (payrollStatus === "decline") {
                            cellContent = <span className="text-danger">Payroll Rejected</span>;
                        }
                        else {
                            cellContent = <span className="text-warning">Payroll Pending</span>;
                        }
                        break;
                        
                    // 2. Bank Status
                    case 'bank_status_col': // Use the accessorKey you defined for this column
                        const bankstatus = row.bankstatus?.toLowerCase();
                        
                        if (bankstatus === "pending") {
                            // Assuming EditData and aid are available in this scope
                            cellContent = (
                                <button
                                    className="btn btn-sm btn-primary"
                                    onClick={() => EditData(row.id, aid)} 
                                >
                                    Verify
                                </button>
                            );
                        } else if (bankstatus === "success") {
                            cellContent = <span className="text-success">Bank Verified</span>;
                        } else if (bankstatus === "decline") {
                            // Assuming EditData and aid are available in this scope
                            cellContent = (
                                <div className="d-flex flex-column">
                                    <span className="text-danger">Bank Failed</span>
                                    <button
                                        className="btn btn-sm btn-warning mt-1"
                                        onClick={() => EditData(row.id, aid)}
                                    >
                                        Re-Verify
                                    </button>
                                </div>
                            );
                        } else {
                            cellContent = null;
                        }
                        break;
                         default:
                        // Default rendering for other columns (Client Name, Mobile, etc.)
                        const value = column.selector ? column.selector(row) : null;
                        cellContent = value;
                        break;
                }

                return (
                    <TableCell 
                        key={column.accessorKey}
                        sx={{ p: 1.5, fontSize: '0.875rem',minWidth:cellWidth,width:cellWidth}}>
                        {cellContent}
                    </TableCell>
                );
            })}
        </TableRow>
    ))}
    
    {/* Empty state if no data */}
    {processedData.length === 0 && (
        <TableRow>
            <TableCell colSpan={columns.length} align="center" sx={{ py: 4 }}>
                <Typography color="textSecondary" variant="body1">
                    No matching found in the current filters.
                </Typography>
            </TableCell>
        </TableRow>
    )}
</TableBody>
               
            </Table>
            </TableContainer>
          
                </div>
                <div className="card-footer d-flex align-items-center justify-content-between" style={{ padding: '10px 25px' }}>
    <p className="text-muted mb-0">
        Showing <strong>{((currentPage - 1) * limit) + 1}</strong> – <strong>{Math.min(currentPage * limit, totalRows)}</strong> of <strong>{totalRows}</strong> entries
    </p>

    <nav aria-label="Page navigation">
        <ul className="pagination mb-0">
            {/* First Page */}
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(1)}>« First</button>
            </li>

            {/* Previous */}
            <li className={`page-item ${currentPage <= 1 ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(prev => prev - 1)}>&laquo;</button>
            </li>

            {/* Dynamic Page Numbers */}
            {pages.map(pageNum => (
                <li key={pageNum} className={`page-item ${currentPage === pageNum ? 'active' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(pageNum)}>
                        {pageNum}
                    </button>
                </li>
            ))}

            {/* Next */}
            <li className={`page-item ${currentPage >= maxPage ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(prev => prev + 1)}>&raquo;</button>
            </li>

            {/* Last Page */}
            <li className={`page-item ${currentPage === maxPage ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(maxPage)}>Last »</button>
            </li>
        </ul>
    </nav>
                </div>
              </div>

            </div>
          </div>


</div></div>

</>
);
}
export default Onboarded;
